export default __webpack_public_path__ + "navigation-examples-custom-banner-thumbnail-v1-960-c078ec85c06e4d66099fcee73fa45676.webp";